export { default as LoginSingleSignOn } from './login-single-sign-on';
